import { Pipe, PipeTransform } from '@angular/core';

const charactersThatNeedEscaping = /[&<>"']/;
const rAmp = /&/g;
const rLt = /</g;
const rGt = />/g;
const rApos = /'/g;
const rQuot = /"/g;

// Based on work done in https://github.com/parshap/html-escape/blob/master/index.js

export function escapeHtml(value: string): string {
  if (!value) return '';

  // Only run if there are characters that need escaping
  if (charactersThatNeedEscaping.test(value)) {
    return value
      .replace(rAmp, '&amp;')
      .replace(rLt, '&lt;')
      .replace(rGt, '&gt;')
      .replace(rApos, '&apos;')
      .replace(rQuot, '&quot;');
  } else {
    return value;
  }
}

/**
 * This pipe will take a string and escape any html characters that are present
 * in the string to prevent XSS attacks and other security vulnerabilities
 * @param value
 * @return escaped string
 */
@Pipe({ name: 'glxyEscapeHtml'})
export class EscapeHtmlPipe implements PipeTransform {
  transform(value: string): string {
    return escapeHtml(value);
  }
}
